<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.youZanSignDateList.push"
    :is-show-search-input="true"
    search-placeholder="输入标题或副标题关键词进行搜索"
  >
    <v-column-time/>
    <el-table-column label="ID" prop="id" width="100px"/>

    <v-column-avatar label="添加者"/>
    <el-table-column label="标题关键词" prop="title" width="210px"/>
    <el-table-column label="副标题关键词" prop="title_sub" width="210px"/>
    <v-column-time field="sign_date" time-format="timeToYmd" value="日期"/>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.youZanSignDateEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此设置吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`you-zan-sign-date-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加者</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>标题关键词</span>
              <span>{{ v.title }}</span>
            </div>
            <div class="list-item-detail">
              <span>副标题关键词</span>
              <span>{{ v.title_sub }}</span>
            </div>
            <div class="list-item-detail">
              <span>日期</span>
              <span>{{ v.sign_date | timeToYmd }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.youZanSignDateEdit.to(v.id)"/>
              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此设置吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/you-zan-sign-date';

export default {
  name: RouteConfig.youZanSignDateList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (!id) return this.$message.warning('缺少 ID 标识，无法删除该设置！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, { update_time });
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
